module.exports = __webpack_public_path__ + "fonts/roboto-condensed-v18-latin-regular.4a6300d.woff";